const locale = {
  placeholder: 'Zaman Seç',
};

export default locale;
